export default __webpack_public_path__ + "static/media/identifiercfg_card.fdd720cc.jpg";